/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowCollapseTrianglesVOpenIcon20Solid = forwardRef('ArrowCollapseTrianglesVOpenIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "m4.786 7.464 3.977-3.977a1.75 1.75 0 0 1 2.474 0l3.977 3.977C15.78 8.03 15.379 9 14.577 9H5.423c-.802 0-1.204-.97-.637-1.536Z" }),
        React.createElement("path", { d: "m4.786 12.536 3.977 3.976a1.75 1.75 0 0 0 2.474 0l3.977-3.976c.567-.567.165-1.536-.637-1.536H5.423c-.802 0-1.204.97-.637 1.536Z" })));
});
